import React from "react";
import type { TransformedProduct } from "../../../../types/productApiTypes";

/**
 * Renders the product's category and name.
 */
const ProductHeader: React.FC<{ product: TransformedProduct }> = ({
  product,
}) => (
  <>
    {product.enrichedCategories[0] && (
      <p className="product-info-details__category">
        {product.enrichedCategories[0].name}
      </p>
    )}
    <h1 className="product-info-details__name">{product.name}</h1>
  </>
);

export default ProductHeader;
